import Tax from '../../../../icons/tax.svg';
import Premium from '../../../../icons/premium.svg';
import MoneyBack from '../../../../icons/moneyback.svg';
import RoboChat from '../../../../icons/RoboChat.svg';
import receiveCall from '../../../../icons/receiveCall.svg';
import review from '../../../../icons/review.svg';
import submitApplication from '../../../../icons/submitApplication.svg';
import shieldProtected3 from '../../../../icons/shieldProtected3.svg';

export const BestFeatures = [
  {
    text: "No premiums due until your policy is approved",
    icon: Premium
  },
  {
    text: "10 day Money Back Guarantee",
    icon: MoneyBack
  },
  {
    text: "You can cancel your policy anytime",
    icon: Premium
  },
  {
    text: "Life Insurance Proceeds are typically tax free at distribution",
    icon: Tax
  },
  {
    text: "Change your beneficiary at any time",
    icon: Tax
  },
];

export const EasySteps = [
  {
    text: "Look for a call from a 208 area code",
    icon: receiveCall
  },
  {
    text: "Speak with your licensed expert to review your best options",
    icon: review
  },
  {
    text: "Choose your solution and let us handle the application",
    subTitle: "No payment is due until you review and approve your policy",
    icon: submitApplication
  },
  {
    text: "Once approved, sign and pay initial premium to activate your coverage",
    icon: shieldProtected3
  },
];

export const InsurancePlan = [
  {
    title: "Want coverage for another person?",
    content: "Getting your spouse insured can be just as important as your own insurance.",
    icon: RoboChat,
    btnTitle: 'GET A QUOTE',
    linkTo: '/landing/term-insurance'
  },
  {
    title: "Other Insurance Options",
    content: "Explore coverage options in a variety of categories, all from your mobile device.",
    icon: RoboChat,
    btnTitle: 'SEE PRODUCTS',
    linkTo: '/'
  },
  {
    title: "Policy Review",
    content: "Save money on your existing insurance policies with a free no obligation policy review.",
    icon: RoboChat,
    btnTitle: 'GET A POLICY REVIEW',
    linkTo: '/policy-review'
  },
];



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Helpers/Constant.js